import { useRef, useState } from "react";
import MenuFlottant from "../MenuFlottant/MenuFlottant";

// Actions rares du lead (exports…), derrière un bouton « Plus d'actions ».
// `actions` : [{ id, icone, libelle, aide, onClick }].
const MenuActionsLead = ({ actions = [] }) => {
  const [ouvert, setOuvert] = useState(false);
  const refBouton = useRef(null);

  const lancer = (action) => {
    setOuvert(false);
    action.onClick();
  };

  return (
    <div className="la-ancre">
      <button
        ref={refBouton}
        type="button"
        className="la-bouton-icone"
        aria-haspopup="menu"
        aria-expanded={ouvert}
        aria-label="Plus d'actions"
        title="Plus d'actions"
        onClick={() => setOuvert((valeur) => !valeur)}
      >
        <i className="fa fa-ellipsis-h" aria-hidden="true" />
      </button>
      <MenuFlottant ouvert={ouvert} onFermer={() => setOuvert(false)} refBouton={refBouton} titre="Plus d'actions">
        {actions.map((action) => (
          <button key={action.id} type="button" role="menuitem" className="la-menu__item" onClick={() => lancer(action)}>
            <i className={`fa ${action.icone || "fa-circle"} la-menu__icone`} aria-hidden="true" />
            {action.libelle}
            {action.aide && <small className="la-menu__aide">{action.aide}</small>}
          </button>
        ))}
      </MenuFlottant>
    </div>
  );
};

export default MenuActionsLead;
